//utils/perm.js


export const normKey = (k) =>
  String(k || "")
    .trim()
    .toLowerCase()
    .replace(/\s+/g, "_")
    .replace(/-/g, "_");

export const getPerm = (permissionsMap, moduleKey) => {
  if (!moduleKey) return null;
  const key = normKey(moduleKey);
  return permissionsMap?.[key] || null;
};
